import { render, staticRenderFns } from "./the-header-actions.vue?vue&type=template&id=50c0861c&"
import script from "./the-header-actions.vue?vue&type=script&lang=js&"
export * from "./the-header-actions.vue?vue&type=script&lang=js&"
import style0 from "./the-header-actions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports